<template>
  <div class="document-categories" v-if="categories !== undefined">
    <div v-if="categories === null">
      <span class="ln-sm-text ln-darkblue">Kategorijos kraunamos...</span>
    </div>
    <div v-else-if="categories.length === 0"></div>
    <div v-else>
      <div class="category-tags">
        <template v-for="(category, catIndex) in categories">
          <button
            v-if="interactive"
            :key="`cat-btn-${catIndex}`"
            type="button"
            class="category-tag ln-sm-text ln-darkblue"
            @click.stop="triggerSearchByCategory(category)"
            title="Atlikti paiešką pagal kategoriją"
          >#{{ category.categoryName }}</button>
          <span
            v-else
            :key="`cat-${catIndex}`"
            class="category-tag ln-sm-text ln-darkblue"
          >#{{ category.categoryName }}</span>

          <template v-if="category.subCategories && category.subCategories.length > 0">
            <span :key="`open-${catIndex}`" class="category-tag-plus ml-1" aria-hidden="true">(</span>

            <template v-if="category.expanded || !interactive">
              <template v-for="(subCat, subIndex) in category.subCategories">
                <button
                  v-if="interactive"
                  :key="`sub-btn-${catIndex}-${subIndex}`"
                  type="button"
                  :class="['subcategory-item', `sub-item-${catIndex}-${subIndex}`]"
                  @click.stop="triggerSearchByCategory(category, subCat)"
                  title="Atlikti paiešką pagal subkategoriją"
                >{{ subCat.name }}</button>
                <span
                  v-else
                  :key="`sub-${catIndex}-${subIndex}`"
                  :class="['subcategory-item', `sub-item-${catIndex}-${subIndex}`]"
                >{{ subCat.name }}</span>
                <span
                  v-if="subIndex < category.subCategories.length - 1"
                  :key="`sep-${catIndex}-${subIndex}`"
                  aria-hidden="true"
                >, </span>
              </template>
            </template>

            <template v-else-if="interactive">
              <button
                v-if="category.subCategories.length === 1"
                :key="`single-${catIndex}`"
                type="button"
                :class="['subcategory-item', `sub-item-${catIndex}-0`]"
                @click.stop="triggerSearchByCategory(category, category.subCategories[0])"
                title="Atlikti paiešką pagal subkategoriją"
              >{{ category.subCategories[0].name }}</button>
              <button
                v-else
                :key="`expand-${catIndex}`"
                type="button"
                class="category-tag-plus"
                :aria-expanded="category.expanded ? 'true' : 'false'"
                @click.stop="expandSubCategories(category)"
                :aria-label="`Rodyti ${category.subCategories.length} subkategorijas`"
              >{{ category.subCategories.length }}</button>
            </template>

            <span :key="`close-${catIndex}`" class="category-tag-plus" aria-hidden="true">)</span>
          </template>

          <span
            v-if="catIndex < categories.length - 1"
            :key="`gap-${catIndex}`"
            aria-hidden="true"
          >&nbsp;</span>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "document-category",
  props: {
    categories: {
      type: Array,
      default: () => []
    },
    interactive: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    expandSubCategories(category) {
      if (!category.subCategories || category.subCategories.length <= 1) {
        return;
      }
      if (!category.expanded) {
        this.$set(category, 'expanded', true);
      }
    },
    triggerSearchByCategory(category, subCategory = null) {
      const query = { isplestine: 'true' };
      let categoryId = category ? category.categoryId : null;
      let subcategoryId = subCategory ? subCategory.id : null;

      if (subcategoryId) categoryId = undefined;
      if (categoryId) query.kategorijos = String(categoryId);
      if (subcategoryId) query.subkategorijos = String(subcategoryId);

      this.$emit('searchEvent', query);
    }
  }
};
</script>

<style scoped>
.category-tags {
  font-size: 0.9em;
}

.category-tags .ln-sm-text {
  font-size: var(--doc-cat-font-size, 12px)!important;
}

/* Neutralize browser <button> defaults so chips render as inline text */
.category-tags button {
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  text-align: left;
  cursor: pointer;
}

/* Match original inline font-size for sibling chip elements */
.category-tags button,
.category-tags > span {
  font-size: var(--doc-cat-font-size, 12px) !important;
}

.category-tag {
  margin-right: 6px;
  margin-bottom: 4px;
  border-radius: 5px;
  display: inline;
  color: #080b58;
  font-weight: 400;
}

button.category-tag:hover {
  color: #0056b3 !important;
}

.category-tag-plus {
  font-weight: 400;
  color: #080b58;
  user-select: none;
}

button.category-tag-plus:hover {
  color: #0056b3 !important;
}

.subcategory-item {
  display: inline;
  color: #080b58;
  transition: color 0.2s ease;
}

button.subcategory-item:hover {
  color: #0056b3 !important;
}

@media (max-width: 576px) {
  .category-tag {
    display: block;
    margin-top: 4px;
    width: fit-content;
  }
  
  .subcategory-tag {
    display: inline;
  }
}
</style>